import React from "react";
import TextContainer from "./TextContainer";
import AvailableOn from "./AvailableOn";
import MainDiv from "./MainDiv";
import { TextContainerDivs } from "./Containers";

export default function HomeLayout() {
  return (
    <div className="home">
      <MainDiv />
      
      <AvailableOn/>
      
      {TextContainerDivs.map((div, index) => (
        <TextContainer
          key={index}
          bgLink={div.bgLink}
          title={div.title}
          subTitle={div.subTitle}
          description={div.description}
          inverted={div.inverted}
          mobileBg={div.mobileBg}
        />
      ))}
    </div>
  );
}
